<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Pitko</h1>
          <figure class="image is-4by3">
            <img src="static/images/pitko/pitko_02.jpg">
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px;">
          <p class="title">Pitko bench was designed for Fiskars Village Art & Design Biennale exhibition Social seating, curated by Jasper Morrison.</p>
          <p>
            The 3 meters long bench got its inspiration from the finnish piers where people can sit and lay down freely watching the sky or the landscape. The bench is made by a group of students and teachers at Luksia Artisan school. The material is untreated larch that will get a natural patina over time.
          </p>
          <br>
          <p>Photography: Kerttu Penttilä / Päivi Keski-Pomppu</p>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img class="zoom-default" data-zoom-src="static/images/pitko/pitko_03-highres.jpg" src="static/images/pitko/pitko_03.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img class="zoom-default" data-zoom-src="static/images/pitko/pitko_05-highres.jpg" src="static/images/pitko/pitko_05.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img src="static/images/pitko/pitko_04.jpg">
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import mediumZoom from 'medium-zoom'

export default {
  mounted () {
    mediumZoom('.zoom-default')
  }
}

</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Pitko.vue